import { DataType } from '@easydata/core';
import { equtils } from '../utils/utils';
import { DataKind } from '../types/data_kind';
import { ExprTag } from '../types/expr_tag';
/**
 * Represents expression object.
 */
var Expression = /** @class */ (function () {
    /** The default constructor. */
    function Expression(parent) {
        var _this = this;
        this.parent = parent;
        /** The tag. */
        this.tag = ExprTag.Constant;
        /** The data kind. */
        this.kind = DataKind.Scalar;
        /** The data type. */
        this.dataType = DataType.Unknown;
        /** The value. */
        this._value = ''; //DO NOT forget remove any
        /**
         * The distinct option. (e.g `SELECT DISTINCT`)
         */
        this.distinct = false;
        this._isDefaultValue = false;
        this.getText = function () { return _this.text || _this._value; };
        this.args = new Array();
    }
    Expression.prototype.getParent = function () {
        return this.parent;
    };
    Expression.prototype.getModel = function () {
        return this.parent.getQuery().getModel();
    };
    /**
     * Loads expression from its JSON representation object.
     * @param model The Data Model.
     * @param data The JSON representation object.
     */
    Expression.prototype.loadFromData = function (model, data) {
        if (data) {
            this.tag = data.tag;
            if (data.val) {
                this._value = data.val;
                this.text = data.txt;
            }
            else if (data.id) {
                this.kind = DataKind.Attribute;
                this._value = data.id;
                this.text = data.txt;
            }
            if (typeof data.dtype !== 'undefined') {
                this.dataType = data.dtype;
            }
            if (this.tag == ExprTag.EntityAttribute
                || this.tag == ExprTag.ParentEntityAttribute) {
                this.kind = DataKind.Attribute;
                //We don't load other info for EntityAttr
            }
            else {
                if (typeof data.kind !== 'undefined') {
                    this.kind = data.kind;
                }
                if (data.query) {
                    this.subQuery = this.parent.getQuery().createSubQuery();
                    this.subQuery.loadFromDataOrJson(data.query);
                }
                if (typeof data.distinct !== 'undefined') {
                    this.distinct = data.distinct;
                }
                if (data.func) {
                    this.func = data.func;
                    if (data.args) {
                        for (var i = 0; i < data.args.length; i++) {
                            var arg = new Expression(this.parent);
                            arg.loadFromData(model, data.args[i]);
                            this.args.push(arg);
                        }
                    }
                }
                if (data.sql) {
                    this.sql = data.sql;
                    this.baseAttrId = data.baseAttrId;
                }
            }
        }
    };
    /**
    * Saves expression from JSON representation object.
    * @returns The JSON representation object.
    */
    Expression.prototype.saveToData = function () {
        var obj = {
            tag: this.tag
        };
        obj.dtype = this.dataType;
        //Do not save other info for EntityAttr
        if (this.tag == ExprTag.EntityAttribute || this.tag == ExprTag.ParentEntityAttribute) {
            if (this._value) {
                obj.id = this._value;
                obj.val = this._value;
            }
            if (this.text) {
                obj.txt = this.text;
            }
            //Do not save other info for EntityAttr
        }
        else {
            if (this.subQuery) {
                obj.query = this.subQuery.toJSONData();
            }
            if (typeof this.kind !== "undefined") {
                obj.kind = this.kind;
            }
            if (this._value) {
                obj.val = this._value;
            }
            if (this.text) {
                obj.txt = this.text;
            }
            if (this.distinct) {
                obj.distinct = this.distinct;
            }
            if (this.func) {
                obj.func = this.func;
                obj.args = [];
                for (var i = 0; i < this.args.length; i++) {
                    obj.args.push(this.args[i].saveToData());
                }
            }
            if (this.sql) {
                obj.sql = this.sql;
                obj.baseAttrId = this.baseAttrId;
            }
        }
        return obj;
    };
    Expression.prototype.getIndex = function () {
        return this.parent.getExpressionIndex(this);
    };
    Object.defineProperty(Expression.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Expression.prototype.setValue = function (val, silent) {
        if (silent === void 0) { silent = false; }
        this.setContent(val, undefined, silent);
    };
    Expression.prototype.setContent = function (val, txt, silent) {
        if (silent === void 0) { silent = false; }
        var oldValue = this.value;
        if (this.kind == DataKind.Attribute && val) {
            var attr = this.getModel().getAttributeById(val);
            if (!attr) {
                throw "No such entity attribute:" + val;
            }
            this.dataType = attr.dataType;
        }
        this._value = val;
        if (typeof txt !== 'undefined') {
            this.text = txt;
        }
        else if (typeof this.text !== 'undefined') {
            this.text = val;
        }
        this._isDefaultValue = false;
        if (!silent) {
            this.parent.expressionChanged(this, oldValue);
        }
    };
    Expression.prototype.isEmpty = function () {
        return !(this.text || this._value);
    };
    Expression.prototype.hasText = function () {
        return this.text && this.text.length > 0;
    };
    Expression.prototype.tryCopyValueFrom = function (expr) {
        if (this.kind == expr.kind) {
            if (this.dataType == expr.dataType) {
                this.setContent(expr.value.length ? expr.value : this._value, (expr.text && expr.text.length) ? expr.text : this.text, true);
            }
            else {
                var val = equtils.convertValue(expr.value, expr.dataType, this.dataType);
                this.setContent(val.length ? val : this._value, (expr.text && expr.text.length) ? expr.text : this.text, true);
            }
            this.subQuery = expr.subQuery;
            this.sql = expr.sql;
            this.baseAttrId = expr.baseAttrId;
        }
        else if (!this._isDefaultValue) {
            this.setContent('', '', true);
            this.subQuery = null;
            this.sql = null;
            this.baseAttrId = null;
        }
    };
    return Expression;
}());
export { Expression };
//# sourceMappingURL=expression.js.map